import { defineComponent, ref, computed, resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, createVNode, createTextVNode, toDisplayString, withModifiers, createCommentVNode } from 'vue';
import { OrIconV3 as script$1 } from '../or-icon-v3/index.js';
import { OrIconButtonV3 as script$2 } from '../or-icon-button-v3/index.js';
import '../OrAutocompleteV3-508d99c0.js';
import '@vueuse/core';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import 'lodash/get';
import 'lodash/isElement';
import '../or-error-v3/index.js';
import '../or-hint-v3/index.js';
import '../or-input-box-v3/index.js';
import '../or-input-v3/index.js';
import '../OrInlineInputV3-46210775.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-label-v3/index.js';
import '../or-loader-v3/index.js';
import '../or-menu-item-v3/index.js';
import '../or-tooltip-v3/index.js';
import '../or-popover-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-overlay-v3/index.js';
import '../or-teleport-v3/index.js';
import '../or-tag-input-v3/index.js';
import '../or-tags-v3/index.js';
import '../or-button-v3/index.js';
import '../or-tag-v3/index.js';

const FilterTrigger = [
// Layout
'layout-row',
// Interactivity
'interactivity-click',
// Shape
'rounded-full',
// Box
'h-[44px] md:h-[32px]',
// Spacing
'px-md md:px-sm+', 'py-0', 'gap-md+ md:gap-md',
// Typography
'typography-button',
// Theme
'theme-foreground-default', 'dark:theme-foreground-default-dark',
// Theme (hover)
'hover:theme-foreground-primary-hover', 'dark:hover:theme-foreground-primary-hover-dark', 'hover:theme-background-primary-translucent-1', 'dark:hover:theme-background-primary-translucent-1-dark',
// Theme (selected)
'selected:theme-foreground-primary', 'dark:selected:theme-foreground-primary-dark', 'selected:theme-background-primary-translucent-1', 'dark:selected:theme-background-primary-translucent-1-dark',
// Theme (activated)
'activated:theme-background-primary-translucent-1', 'dark:activated:theme-background-primary-translucent-1-dark',
// Theme (.icon)
'[&_.icon]:theme-foreground-primary', 'dark:[&_.icon]:theme-foreground-primary-dark',
// Theme (.icon / hover)
'[&_.icon]:hover:theme-foreground-primary-hover', 'dark:[&_.icon]:hover:theme-foreground-primary-hover-dark'];
const FilterTriggerLabel = [
// Layout
'layout-row',
// Spacing
'gap-xs'];
const FilterTriggerTag = [
// Layout
'layout-row',
// Shape
'rounded-full',
// Box
'h-[36px] md:h-[24px]',
// Spacing
'px-sm+ md:px-sm', 'py-0', 'gap-sm+ md:gap-sm',
// Theme
'theme-foreground-default', 'dark:theme-foreground-default-dark', 'theme-background-default', 'dark:theme-background-default-dark'];

var script = defineComponent({
  name: 'OrFilterTrigger',
  components: {
    OrIcon: script$1,
    OrIconButton: script$2
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: undefined
    },
    label: {
      type: String,
      default: 'Filters'
    }
  },
  emits: ['reset', 'click'],
  expose: ['root'],
  setup(props, context) {
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-filter-trigger-v3', ...FilterTrigger]);
    const labelStyles = computed(() => [...FilterTriggerLabel]);
    const tagStyles = computed(() => [...FilterTriggerTag]);
    // Methods
    function reset() {
      context.emit('reset');
    }
    return {
      root,
      rootStyles,
      labelStyles,
      tagStyles,
      reset
    };
  }
});

const _hoisted_1 = ["selected", "activated"];
const _hoisted_2 = {
  key: 0,
  class: /*#__PURE__*/normalizeClass(['layout-inline-row', '-m-[12px] md:-m-[8px]'])
};
const _hoisted_3 = {
  class: /*#__PURE__*/normalizeClass(['layout-inline-row', '-m-[4px]'])
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIcon = resolveComponent("OrIcon");
  const _component_OrIconButton = resolveComponent("OrIconButton");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    selected: _ctx.isOpen,
    activated: !!_ctx.value,
    onClick: _cache[1] || (_cache[1] = e => _ctx.$emit('click', e))
  }, [createElementVNode("div", {
    class: normalizeClass(_ctx.labelStyles)
  }, [createVNode(_component_OrIcon, {
    class: normalizeClass('icon'),
    icon: 'filter_list'
  }), createTextVNode(" " + toDisplayString(_ctx.label), 1 /* TEXT */)], 2 /* CLASS */), _ctx.value ? (openBlock(), createElementBlock("div", _hoisted_2, [createElementVNode("div", {
    class: normalizeClass(_ctx.tagStyles)
  }, [createTextVNode(toDisplayString(_ctx.value) + " ", 1 /* TEXT */), createElementVNode("div", _hoisted_3, [createVNode(_component_OrIconButton, {
    icon: 'close',
    onClick: _cache[0] || (_cache[0] = withModifiers($event => _ctx.reset(), ["stop"]))
  })])], 2 /* CLASS */)])) : createCommentVNode("v-if", true)], 10 /* CLASS, PROPS */, _hoisted_1);
}

script.render = render;
script.__file = "src/components/or-filter-trigger-v3/OrFilterTrigger.vue";

export { script as OrFilterTriggerV3 };
